import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=57f37913&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=57f37913&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f37913",
  null
  
)

export default component.exports